import InteractionInsight from '@/lib/insights/models/InteractionInsight';
import { shareableLocation } from '@/lib/util/shareables';

export const AssetAccessVisibilityTypes = {
  error: -1,
  undetermined: 0,
  determined: 1,
};

class AssetDisplayDetail {
  isAccessible = true;

  accessVisibilityStatus = AssetAccessVisibilityTypes.undetermined;

  interactionInsight = new InteractionInsight();

  assetId = 0;

  id = 0;

  docId = '';

  title = '';

  customizationSettings = null;

  constructor(
    assetId = 0,
    docId = '',
    isAccessible = true,
    insight = new InteractionInsight(),
  ) {
    this.assetId = assetId;
    this.id = assetId;
    this.docId = docId;
    this.isAccessible = isAccessible;
    this.interactionInsight = insight;
    this.customizationSettings = null;
  }

  get rawLocation() {
    return { name: 'content-page', params: { id: this.docId } };
  }

  get accessibilityOptions() {
    return {
      status: this.accessVisibilityStatus,
      accessible: this.isAccessible,
    };
  }

  shareableObject(preview = true) {
    return {
      name: this.title,
      type: 'Document',
      location: shareableLocation(this.rawLocation)(preview),
    };
  }

  static fromObject({
    assetId, docId, isAccessible, interactionInsight,
  }) {
    return new AssetDisplayDetail(
      assetId, docId,
      isAccessible,
      (interactionInsight && InteractionInsight.fromObject(interactionInsight)),
    );
  }

  setCustomizationSettings(settings) {
    this.customizationSettings = settings;
  }
}

export default AssetDisplayDetail;
